module.exports = __webpack_public_path__ + "3664009cf60829d04de7eca015a3618a.svg";